import { IAddFormPublishTermsResponse } from '../../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { IDurationState } from '../../../../../reducers/v2';

export const mapDurations = (response: IAddFormPublishTermsResponse): IDurationState => {
  let defaultDuration = 1;

  if (!response.auction?.durations) {
    return {
      defaultDuration,
      durations: [],
    };
  }

  const durations = response.auction.durations.map(duration => {
    if (duration.isSelected) {
      defaultDuration = duration.durationInDays;
    }

    return {
      durationInDays: duration.durationInDays,
      discountPercent: duration.discountPercent,
      selected: duration.isSelected,
      isPromoDiscount: duration.isPromoDiscount,
    };
  });

  return {
    defaultDuration,
    durations,
  };
};
